/**
 * Team Workload Card
 *
 * Horizontal bar chart showing tasks per assignee.
 */

import ChartContainer from '@/components/charts/ChartContainer';
import BarChart from '@/components/charts/BarChart';
import type { WorkloadItem } from '../types';

interface TeamWorkloadCardProps {
  data?: WorkloadItem[];
  loading?: boolean;
}

const WORKLOAD_COLORS = ['#3b82f6', '#22c55e', '#f59e0b', '#a855f7', '#06b6d4', '#ec4899'];

export function TeamWorkloadCard({ data, loading }: TeamWorkloadCardProps) {
  // Take top 6 team members by task count
  const chartData = data
    ? data.slice(0, 6).map((item) => ({
        name: item.assignee_name || 'Unassigned',
        value: item.task_count,
        overdue: item.overdue_count,
        inProgress: item.in_progress_count,
      }))
    : [];

  const hasData = chartData.length > 0;

  return (
    <ChartContainer
      title="Team Workload"
      description={hasData ? `${data?.length || 0} team members with tasks${(data?.length || 0) > 6 ? ` (showing top 6)` : ''}` : undefined}
      loading={loading}
      height={220}
    >
      {hasData ? (
        <BarChart
          data={chartData}
          dataKey="value"
          xAxisKey="name"
          height={220}
          horizontal
          colorByValue
          colors={WORKLOAD_COLORS}
          barSize={16}
        />
      ) : (
        <div className="flex items-center justify-center h-full text-muted-foreground text-sm">
          No workload data available
        </div>
      )}
    </ChartContainer>
  );
}
